var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, QueryList, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSnackBar } from '@angular/material';
import { ChapterCardComponent } from '../chapter-card/chapter-card.component';
import { filter, map, takeUntil } from 'rxjs/operators';
import { SelectChapter, SetChapters, NextChapter, PreviousChapter, RemoveChapter, DuplicateChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { ImportStory } from 'src/app/story/state/story.actions';
var ChapterBrowserComponent = /** @class */ (function () {
    function ChapterBrowserComponent(store, dialogService, snackbar) {
        this.store = store;
        this.dialogService = dialogService;
        this.snackbar = snackbar;
        this.allChaptersLoaded = false;
        this.ngUnsubscribe = new Subject();
        this.currentChapterId = '';
    }
    ChapterBrowserComponent.prototype.ngOnInit = function () {
        this.allChaptersLoaded = this.store.selectSnapshot(StoryChaptersState.getStoryChapters)
            .every(function (chapter) { return chapter.readyState.model; });
    };
    ChapterBrowserComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ChapterBrowserComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.selectedChapter$
            .pipe(filter(function (selectedChapter) { return selectedChapter != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (selectedChapter) {
            _this.currentChapterId = selectedChapter.id;
            setTimeout(function () {
                _this.scrollChapterIntoView(selectedChapter);
            });
        });
        this.chapters$
            .pipe(filter(function (chapters) { return chapters != null && chapters.length > 0; }), map(function (chapters) {
            return chapters.every(function (chapter) { return chapter.readyState.model === true; });
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (allChaptersLoaded) {
            _this.allChaptersLoaded = allChaptersLoaded;
        });
    };
    ChapterBrowserComponent.prototype.handleDrop = function (event) {
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        moveItemInArray(chapters, event.previousIndex, event.currentIndex);
        this.store.dispatch(new SetChapters(chapters));
    };
    ChapterBrowserComponent.prototype.handleClickChapter = function (chapter) {
        if (chapter.id !== this.currentChapterId) {
            this.store.dispatch(new SelectChapter(chapter));
        }
    };
    ChapterBrowserComponent.prototype.handleImportChapters = function () {
        var _this = this;
        var dialogRef = this.dialogService.openImportDialog();
        dialogRef.afterClosed()
            .pipe(filter(function (bookmark) { return bookmark != null; }))
            .subscribe(function (bookmark) {
            _this.store.dispatch(new ImportStory(bookmark.id, bookmark.type));
        });
    };
    ChapterBrowserComponent.prototype.handleNextClick = function () {
        this.store.dispatch(new NextChapter());
    };
    ChapterBrowserComponent.prototype.handlePreviousClick = function () {
        this.store.dispatch(new PreviousChapter());
    };
    ChapterBrowserComponent.prototype.handleDuplicate = function (chapter) {
        this.duplicateChapter(chapter);
    };
    ChapterBrowserComponent.prototype.handleDuplicateSelected = function () {
        var chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        this.duplicateChapter(chapter);
    };
    ChapterBrowserComponent.prototype.handleRemove = function (chapter) {
        this.removeChapter(chapter);
    };
    ChapterBrowserComponent.prototype.duplicateChapter = function (chapter) {
        // exact copy of current chapter
        this.store.dispatch(new DuplicateChapter(chapter));
        this.snackbar.open("Duplicated chapter \"" + chapter.info.displayName + "\"");
    };
    ChapterBrowserComponent.prototype.removeChapter = function (chapter) {
        var _this = this;
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Remove chapter',
                bodyText: 'This cannot be undone.',
                confirmText: 'Remove',
                confirmColor: 'warn'
            }
        });
        dialogRef.afterClosed().subscribe(function (confirmed) {
            if (confirmed) {
                _this.store.dispatch(new RemoveChapter(chapter));
                _this.snackbar.open("\"" + chapter.info.displayName + "\" chapter has been removed");
            }
        });
    };
    ChapterBrowserComponent.prototype.scrollChapterIntoView = function (chapter) {
        var target = document.getElementById("chapter-card__" + chapter.id);
        var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
        if (isSmoothScrollSupported && target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ChapterBrowserComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ChapterBrowserComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getRegisteredThumbnails),
        __metadata("design:type", Observable)
    ], ChapterBrowserComponent.prototype, "thumbnails$", void 0);
    return ChapterBrowserComponent;
}());
export { ChapterBrowserComponent };
